import { render, staticRenderFns } from "./centerCenter.vue?vue&type=template&id=6b64a413&scoped=true&"
import script from "./centerCenter.vue?vue&type=script&lang=js&"
export * from "./centerCenter.vue?vue&type=script&lang=js&"
import style0 from "./centerCenter.vue?vue&type=style&index=0&id=6b64a413&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64a413",
  null
  
)

export default component.exports